export const EVENTS_OBSERVABLE_PRIVATE = Symbol('events-observable-private');
//# sourceMappingURL=privates.js.map